import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"/>
  <circle cx="13.5" cy="6.5" r=".5"/>
  <circle cx="17.5" cy="10.5" r=".5"/>
  <circle cx="6.5" cy="12.5" r=".5"/>
  <circle cx="8.5" cy="7.5" r=".5"/>
</svg>`;

const Arts = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='arts' svg={svg} {...props} />
  )
);

Arts.displayName = 'ArtsIcon';

export default Arts;
